import type { FC, SVGProps } from 'react';

export const BellIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="32"
      height="32"
      fill="currentColor"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill="currentColor"
        d="M24.142 22.8539H23.4992V13.7468C23.4992 9.96731 20.7056 6.8441 17.0709 6.32445V5.28249C17.0709 4.69052 16.5914 4.21106 15.9995 4.21106C15.4076 4.21106 14.9281 4.69052 14.9281 5.28249V6.32445C11.2934 6.8441 8.49982 9.96731 8.49982 13.7468V22.8539H7.85699C7.3829 22.8539 6.99988 23.237 6.99988 23.7111V24.5682C6.99988 24.6861 7.0963 24.7825 7.21415 24.7825H12.9996C12.9996 26.4378 14.3442 27.7825 15.9995 27.7825C17.6548 27.7825 18.9994 26.4378 18.9994 24.7825H24.7849C24.9027 24.7825 24.9991 24.6861 24.9991 24.5682V23.7111C24.9991 23.237 24.6161 22.8539 24.142 22.8539ZM15.9995 26.0682C15.2897 26.0682 14.7138 25.4923 14.7138 24.7825H17.2852C17.2852 25.4923 16.7093 26.0682 15.9995 26.0682ZM10.4283 22.8539V13.7468C10.4283 12.2575 11.0069 10.8593 12.0595 9.8066C13.1121 8.75392 14.5103 8.17535 15.9995 8.17535C17.4887 8.17535 18.8869 8.75392 19.9395 9.8066C20.9922 10.8593 21.5707 12.2575 21.5707 13.7468V22.8539H10.4283Z"
      />
    </svg>
  );
};
